import * as React from 'react';

import fonts from '../../styles/typography.module.css';
import { NAV_HEIGHT } from './utils/config';

export const NavWrapper: React.FC<{ children: React.ReactNode }> = (props) => {
  const { children } = props;
  return (
    <div
      className={`w-screen ${fonts.font}`}
      style={{
        position: 'fixed',
        top: '0px',
        zIndex: '1000',
        height: NAV_HEIGHT,
      }}
    >
      {children}
    </div>
  );
};
NavWrapper.displayName = 'NavWrapper';
